import { ShieldX, LogOut } from "lucide-react";
import { useAuth } from "@/lib/AuthContext";

// Se muestra cuando el dominio abierto pertenece a una franquicia/SaaS
// suspendida, cancelada o con la membresía del usuario desactivada.
export default function SiteBlockedScreen({ site }) {
  const { logout } = useAuth();
  return (
    <div className="fixed inset-0 z-[100] bg-ink flex items-center justify-center p-6">
      <div className="surface w-full max-w-md p-8 text-center">
        <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center border border-destructive/40 bg-destructive/10">
          <ShieldX className="w-7 h-7 text-destructive" />
        </div>
        <h1 className="font-display font-bold uppercase text-xl mb-3">Sitio no disponible</h1>
        <p className="text-sm text-ink-muted mb-5 leading-relaxed">
          {site ? `El acceso a "${site}"` : "El acceso a este sitio"} no está disponible en este momento.
          Comunícate con el administrador del sitio para reactivarlo.
        </p>
        <button onClick={() => logout()} className="inline-flex items-center gap-2 border border-ink-border px-4 py-2 text-sm hover:text-cyan hover:border-cyan">
          <LogOut className="w-4 h-4" /> Cerrar sesión
        </button>
      </div>
    </div>
  );
}